export default __webpack_public_path__ + "static/media/logo-bg.9a2eafc5.png";